import { all, call } from "redux-saga/effects";
import authSagas from "./authentication/sagas";
import examGroupSagas from "./exam-group/sagas";
import examSagas from "./exam/sagas";
import paperSagas from "./paper/sagas";
import subjectSagas from "./subject/sagas";
import questionsSaga from "./questions/sagas";
import topicSagas from "./auto-complete/sagas";
import sectionSagas from "./section/saga";
import transactionsSagas from "./transactions/sagas";
import audioSagas from "./audio/saga";
import feedbackSagas from "./feedback/sagas";
import facultySagas from "./faculties/sagas";
import passwordRecoverySagas from "./password-recovery/sagas";
import departmentSagas from "./departments/sagas";
import quizathonSagas from "./quizathon/sagas";

export default function* rootSaga() {
  yield all([
    call(authSagas),
    call(examGroupSagas),
    call(examSagas),
    call(subjectSagas),
    call(paperSagas),
    call(questionsSaga),
    call(topicSagas),
    call(sectionSagas),
    call(transactionsSagas),
    call(audioSagas),
    call(feedbackSagas),
    call(passwordRecoverySagas),
    call(facultySagas),
    call(departmentSagas),
    call(quizathonSagas)
  ]);
}
